import { Component } from '@angular/core';

@Component({
  selector: 'app-partner-homepage',
  templateUrl: './partner-homepage.component.html',
  styleUrls: ['./partner-homepage.component.scss'],
})
export class PartnerHomepageComponent {}
